var ARMultiSelect = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiselect-wrapper"},[_c('div',{staticClass:"multiselect-container",attrs:{"dir":_vm.direction},on:{"click":_vm.handleBackgroundClick}},[_c('div',{staticClass:"multiselect-dropdown-wrapper",attrs:{"data-test-id":"multiselect-toggle"},on:{"click":_vm.toggleOptions}},[_c('ar-text',{staticClass:"multiselect-copy",attrs:{"size":"14px","text":_vm.listText,"multiple-lines":"","max-lines":1,"line-height":"20px"}}),_vm._v(" "),(!_vm.hideArrow)?_c('ar-icon',{staticClass:"icon-arrow",attrs:{"width":"10px","name":"arrow","rotate":_vm.listOpen ? 180 : 0}}):_vm._e()],1),_vm._v(" "),(_vm.listOpen)?_c('div',{staticClass:"list-search-wrapper"},[_c('ar-search',{staticClass:"multiselect-search",attrs:{"placeholder":_vm.searchPlaceholderText,"data-test-id":"multiselect-search","direction":_vm.direction,"align":!!_vm.direction && (_vm.direction === 'auto' || _vm.direction === 'rtl') ? 'right' : 'left'},model:{value:(_vm.listSearchText),callback:function ($$v) {_vm.listSearchText=$$v;},expression:"listSearchText"}}),_vm._v(" "),_c('div',{staticClass:"multiselect-list-wrapper"},[_vm._l((_vm.filteredList),function(list){return [_c('a',{key:list.value,class:[
              'multiselect-list-link',
              (_vm.direction === 'rtl' || _vm.direction == 'auto') && 'right' ],attrs:{"data-test-id":("multiselect-" + _vm.itemLabel + "-" + (list.name))},on:{"click":function($event){return _vm.selectList(list.value)}}},[(_vm.direction === null || _vm.direction === 'rtl')?_c('div',{staticClass:"item-wrapper"},[_c('ar-checkbox',{ref:("item-multiselect-" + (list.value)),refInFor:true,staticClass:"list-radio",attrs:{"ticked-value":list.value,"value":!!list.selected ? list.value : null},on:{"input":function (val) { return _vm.selectCheckbox(val, list.value); }}}),_vm._v(" "),(typeof list.name === 'string')?_c('ar-text',{class:[
                  'list-name',
                  list.value === _vm.selectedListOid && 'selected' ],attrs:{"size":"xs","text":list.name,"multiple-lines":"","max-lines":1,"line-height":"20px","weight":"normal"}}):_vm._e()],1):(_vm.direction === 'auto' || _vm.direction === 'rtl')?_c('div',{staticClass:"item-wrapper right"},[(typeof list.name === 'string')?_c('ar-text',{class:[
                  'list-name',
                  list.value === _vm.selectedListOid && 'selected' ],attrs:{"size":"xs","text":list.name,"multiple-lines":"","max-lines":1,"line-height":"20px","weight":"normal","direction":"right"}}):_vm._e(),_vm._v(" "),_c('ar-checkbox',{ref:("item-multiselect-" + (list.value)),refInFor:true,staticClass:"list-radio",attrs:{"ticked-value":list.value,"value":!!list.selected ? list.value : null},on:{"input":function (val) { return _vm.selectCheckbox(val, list.value); }}})],1):_vm._e()])]})],2)],1):_vm._e()])])},
staticRenderFns: [],
  name: "Multiselect",
  props: {
    items: {
      type: Array,
      default: null,
    },
    defaultValue: {
      type: Array,
      default: null,
    },
    itemLabel: {
      type: String,
      default: "items",
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
    placeholder: {
      type: String,
      default: null,
    },
    searchPlaceholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      listOpen: false,
      listSearchText: "",
      selectedListOid: [],
      filteredList: [],
    };
  },
  mounted() {
    this.resetDefaults();
    this.selectedListOid = this.defaultValue || [];
    this.filteredList = this.items;
    this.updateSelectedItems();
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.filteredList = this.items;
        this.updateSelectedItems();
      },
    },
    listSearchText() {
      this.filterLists(this.listSearchText);
      this.$emit("updateSearchText", this.listSearchText);
    },
    defaultValue(val) {
      this.selectedListOid = val;
      this.updateSelectedItems();
    },
  },
  computed: {
    listText() {
      if (
        !this.selectedListOid ||
        this.selectedListOid.length == 0 ||
        !this.filteredList
      )
        return `Select ${this.itemLabel}...`;
      return this.filteredList
        .filter((item) => !!item.selected)
        .map((item) => item.name)
        .join(", ");
    },
    searchPlaceholderText() {
      if (!!this.searchPlaceholder) {
        return this.searchPlaceholder
      }

      return `Search ${this.itemLabel}...`
    },
  },
  methods: {
    handleBackgroundClick(e) {
      if (e.target.className === "multiselect-container") {
        this.listOpen = false;
        this.listSearchText = "";
      }
    },
    filterLists(text) {
      this.$emit('search', text);
    },
    selectList(oid) {
      this.$refs[`item-multiselect-${oid}`][0].toggle();
    },
    toggleOptions() {
      if (this.listOpen) {
        this.listSearchText = "";
      }
      this.listOpen = !this.listOpen;
    },
    resetDefaults() {
      this.selectedListOid = [];
      this.listOpen = false;
      this.listSearchText = "";
    },
    selectCheckbox(checkboxValue, oid) {
      if (!checkboxValue) {
        this.selectedListOid = this.selectedListOid.filter((val) => val != oid);
        const index = this.filteredList.findIndex((listItem) => {
          return listItem.value == oid;
        });

        this.$set(this.filteredList[index], "selected", false);
        this.$emit("select", this.selectedListOid);

        const selectedValues = this.filteredList;
        this.$emit('selectedValues', selectedValues);
      } else {
        if (!this.selectedListOid) {
          this.selectedListOid = [];
        }
        this.selectedListOid.push(oid);
        const index = this.filteredList.findIndex((listItem) => {
          return listItem.value == oid;
        });

        this.$set(this.filteredList[index], "selected", true);
        this.$emit("select", this.selectedListOid);

        const selectedValues = this.filteredList;
        this.$emit('selectedValues', selectedValues);
      }
    },
    updateSelectedItems() {
      if (!this.filteredList || !this.selectedListOid) return null;

      this.filteredList = this.filteredList.map((listItem) => {
        return {
          ...listItem,
          selected: this.selectedListOid.includes(listItem.value),
        };
      });
    },
  },
};

export default ARMultiSelect;
